import { constants } from '../misc/helpers';
import GameManager from './GameManager';
import Tools from './Misc/Tools';

/**
 * Manages the UI
 */
export default class UIManager {

	/**
	 * All registered UIs
	 */
	private _uis: any = {};
	
	/**
	 * ctor
	 * @param gameManager A reference to the Game Manager
	 */
	constructor(public gameManager: GameManager) {
    	this._uis = {};
	}

	/**
	 * Shows a UI on the screen
	 * @param uiName The name of the UI to show
	 * @param parameters The parameters to pass to the UI
	 */
	public showUi<UIParamsType>(uiName: string, parameters?: UIParamsType): void {
    	if(!this._uis[uiName]) {
    		this.gameManager.log('Could not find UI with name ' + uiName);
    		return;
    	}
    	this._uis[uiName].updateCallback({
    		isVisible: true,
    		parameters: parameters ? {...parameters, reset: true} : {reset: true, parameters: {}}
    	});
	}

	/**
	 * Shows a UI on the screen and hides every other UI element
	 * @param uiName The name of the UI to show
	 * @param parameters The parameters to pass to the UI
	 */
	public showSingleUi<UIParamsType>(uiName: string, parameters?: UIParamsType): void {
		this.hideaAllUis();
		this.showUi(uiName, parameters);
	}
	
	/**
	 * Hides all UIs currently visible
	 */
	public hideaAllUis(): void {
    	for(var prop in this._uis) {
    		if (this._uis[prop] === this._uis[constants.InGameUINames.BleedoutTimer]){
				continue;
			}
			if (this._uis[prop] === this._uis[constants.InGameUINames.PauseMenu]){
				continue;
			}
			if (this._uis[prop] === this._uis[constants.InGameUINames.PauseMenuTutorial]){
				continue;
			}
			this._uis[prop].updateCallback({
    			isVisible: false
    		});
    	}
	}

	/**
	 * Hides a single UI
	 * @param uiName The name of the UI to hide
	 */
	public hideUi(uiName: string): void {
    	if(!this._uis[uiName]) {
    		this.gameManager.log('Could not find UI with name ' + uiName);
    		return;
    	}

    	this._uis[uiName].updateCallback({
    		isVisible: false
    	});
	}

	/**
	 * Registers a single UI
	 * @param uiName The name of the UI to register
	 * @param onUpdate Called when showing or hiding the UI
	 */
	public registerUI(uiName: string, onUpdate: (props: any) => void): void {
    	if(this._uis[uiName]) {
    		this.gameManager.log('There is already a UI with name ' + uiName);
    		return;
    	}

    	var id = Tools.generateGuid();

    	this._uis[uiName] = {
    		id: id,
    		updateCallback: onUpdate,
    		show: true        };
	}

	/**
	 * Unregisters a particular UI
	 * @param uiName The name of the UI
	 */
	public unregisterUI(uiName: string): void {
    	if(!this._uis[uiName]) {
    		this.gameManager.log('Could not find UI with name ' + uiName);
    		return;
    	}

    	this.hideUi(uiName);

    	delete this._uis[uiName];
	}
}
